module.exports = function() {
	return new Worker(__webpack_public_path__ + "c01b4358ef245848376a.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader!./app/plugins/GA/lib/ga/SimpleGAWorker.js
// module id = 693
// module chunks = 0